/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://xghufxcbozejxej4srfyjaa2gy.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-kztycjtv4fd4vobzdzkzoc6cca",
    "aws_cognito_identity_pool_id": "us-east-1:b807d5ed-8bc5-4a47-88cc-9df5f3cccb67",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_BHi51j8vF",
    "aws_user_pools_web_client_id": "2flaa7q6dk0jhuk657bnukoe5h",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
